import { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { getIdTokenLocalStorage, decodeToken } from '@sbgsports/vault-sso-auth';

export const useSsoTokenForRequests = (axiosInstance: AxiosInstance) => {
  const token = getIdTokenLocalStorage();

  if (token) {
    axiosInstance.interceptors.request.use(
      (config: InternalAxiosRequestConfig) => {
        // eslint-disable-next-line no-param-reassign
        config.headers.set('Authorization', `Bearer ${token}`);
        return config;
      },
      (e) => {
        console.log(e);
      },
    );
  } else {
    const message = 'No SSO token found to use for API requests.';
    console.error(message);
  }
};

export const getAuthorizationHeaders = () => {
  const token = getIdTokenLocalStorage();
  if (token) {
    return {
      Authorization: `Bearer ${token}`,
    };
  }
  throw Error('No SSO token found');
};

export const getTokenMetadata = () => decodeToken(getIdTokenLocalStorage());
